import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';
import { PlaidError } from '../../Income';

const ErrorRow = styled.tr`
  background-color: ${Color.BACKGROUND_GREY};

  &&& {
    td {
      max-width: none;
    }
  }
`;

const AccountError = ({ text, handleRetry }) => (
  <ErrorRow>
    <td colSpan={3}>
      <PlaidError text={text} handleRetry={handleRetry} />
    </td>
  </ErrorRow>
);

AccountError.propTypes = {
  text: PropTypes.string,
  handleRetry: PropTypes.func,
};

AccountError.defaultProps = {
  text: '',
  handleRetry: null,
};

export default AccountError;
